import { render, staticRenderFns } from "./user-form.component.vue?vue&type=template&id=f4ba76b2"
import script from "./user-form.component.vue?vue&type=script&lang=js"
export * from "./user-form.component.vue?vue&type=script&lang=js"
import style0 from "./user-form.component.vue?vue&type=style&index=0&id=f4ba76b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports